var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ul", { staticClass: "margin-top-lg", style: _vm.componentStyle }, [
    _c(
      "li",
      { class: _vm.featureClass },
      [
        _c("font-awesome-icon", {
          attrs: {
            icon: _vm.$v6.solid.faParachuteBox,
            size: "xl",
            "fixed-width": "",
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "margin-left-lg" }, [
          _vm._v("Hundreds of new icons with each update"),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      { class: _vm.featureClass },
      [
        _c("font-awesome-icon", {
          attrs: {
            icon: _vm.$v6.solid.faWrench,
            size: "xl",
            "fixed-width": "",
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "margin-left-lg" }, [
          _vm._v("The latest software updates and fixes"),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      { class: _vm.featureClass },
      [
        _c("font-awesome-icon", {
          attrs: {
            icon: _vm.$v6.solid.faToolbox,
            size: "xl",
            "fixed-width": "",
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "margin-left-lg" }, [
          _vm._v("Font Awesome Kits, Pro CDN, and other services"),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      { class: _vm.featureClass },
      [
        _c("font-awesome-icon", {
          attrs: {
            icon: _vm.$v6.solid.faUserHeadset,
            size: "xl",
            "fixed-width": "",
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "margin-left-lg" }, [
          _vm._v("\n      Actual Human\n      "),
          _c(
            "span",
            {
              attrs: {
                "aria-label":
                  'No, "Actual Human" isn&apos;t really trademarked. But we will get you unstuck so you can get back to work.',
                "data-balloon-pos": "up",
                "data-balloon-length": "xlarge",
              },
            },
            [
              _c("font-awesome-icon", {
                attrs: {
                  icon: _vm.$v6.regular.faTrademark,
                  size: "sm",
                  transform: "shrink-4 up-4 left-2",
                },
              }),
            ],
            1
          ),
          _vm._v("\n      support from the Font Awesome Team\n    "),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _vm.isShowingBackerPerks
      ? _c(
          "li",
          { class: _vm.featureClass },
          [
            _c("font-awesome-icon", {
              staticStyle: { color: "var(--fa-dk-red)" },
              attrs: {
                icon: _vm.$v6.solid.faMoneyBillAlt,
                size: "xl",
                "fixed-width": "",
              },
            }),
            _vm._v(" "),
            _vm._m(0),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "margin-left-lg" }, [
      _vm._v("\n      … and your super-special\n      "),
      _c("strong", [_vm._v("Backer 50% discount price")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }